import { useEffect, useState } from "react";
import OT from "@opentok/client";
import useSessionId from "./useSessionId";
import { useJoinData } from "../api/helpers";
import LeaveBreadcrumb from "../logging/LeaveBreadcrumb";
import LogError from "../logging/LogError";

const useVonageSession = () => {
  const [vonageSession, setVonageSession] = useState<OT.Session>();
  const sessionId = useSessionId();

  useEffect(() => {
    const onDisconnect = () => {
      setVonageSession(undefined);
    };
    if (vonageSession) {
      vonageSession.on("sessionDisconnected", onDisconnect);
    }

    return () => vonageSession?.off("sessionDisconnected", onDisconnect);
  }, [vonageSession]);

  const joinData = useJoinData();

  useEffect(() => {
    if (
      vonageSession === undefined &&
      joinData?.apiKey &&
      joinData?.sessionId &&
      joinData?.token
    ) {
      const session = OT.initSession(
        joinData?.apiKey,
        joinData.sessionId.toString(),
      );

      session.connect(joinData?.token, (error) => {
        if (error) {
          LogError(error);
        } else {
          LeaveBreadcrumb("Connected to vonage session", {
            vonageSessionId: joinData?.sessionId,
          });
        }
      });
      setVonageSession(session);
    }

    return () => {
      vonageSession?.disconnect();
      setVonageSession(undefined);
    };
    // Don't rerun when vonageSession Changes
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [sessionId, joinData?.apiKey, joinData?.sessionId, joinData?.token]);

  return {
    joinData,
    vonageSession,
  };
};

export default useVonageSession;
